// Recipe data for the app. Used by Home, RecipeDetail, and SEO JSON-LD.

export const ASSETS = {
  toaster: "https://static.prod-images.emergentagent.com/jobs/095313e1-c866-46da-b6f8-9627abf19281/images/f4536a742da90e213991ece0ec699908f7b036baa922c3dfbc6248a54513c03b.png",
  cheeseToast: "https://static.prod-images.emergentagent.com/jobs/095313e1-c866-46da-b6f8-9627abf19281/images/559651262da6b6a1ec6350987a71bcb9d257570ecb489bcc6bf13af421ab4988.png",
  fireFail: "https://static.prod-images.emergentagent.com/jobs/095313e1-c866-46da-b6f8-9627abf19281/images/4df9c0f1f963220663b92409061440949ea201c172a5a167038dab7287d78ff9.png",
  nukeFail: "https://static.prod-images.emergentagent.com/jobs/095313e1-c866-46da-b6f8-9627abf19281/images/c4636fe9caeab2f79f27b4056be6455fd8fed7eaf485c1bd7c9f197860ce88e3.png",
  friedRice: "https://static.prod-images.emergentagent.com/jobs/095313e1-c866-46da-b6f8-9627abf19281/images/23baa3b354c95073b9eb45fed3ca3bbf7725386a5477b8bcbaaeb9fcc1176a2f.png",
  sushi: "https://static.prod-images.emergentagent.com/jobs/095313e1-c866-46da-b6f8-9627abf19281/images/24f4767febfa9919e154a3a6c5aa113ed1daaac58d6a0928a6d6226a8ee2db3f.png",
  eggs: "/img/recipe-eggs.png",
  pasta: "/img/recipe-pasta.png",
  beans: "/img/recipe-beans.png",
  saucepan: "/img/recipe-saucepan.png",
};

export const RECIPES = [
  {
    slug: "cheese-on-toast",
    title: "How to Make Cheese on Toast",
    shortTitle: "Cheese on Toast",
    tagline: "Bread → toaster → cheese → grill. Done.",
    time: "5 min",
    difficulty: "EASY",
    image: ASSETS.cheeseToast,
    flagship: true,
    simulatorPath: "/simulator",
    ingredients: [
      "2 slices of bread",
      "2 slices of cheese (or a small handful grated)",
      "A bit of butter (optional)",
    ],
    tools: ["Toaster", "Grill (or oven on grill setting)", "Baking tray or oven-safe plate"],
    steps: [
      { title: "Bread goes in the toaster", body: "Put 2 slices of bread into the toaster. Push the lever down. Wait for the toast to pop up." },
      { title: "Take the toast OUT of the toaster", body: "Important: the toast comes out of the toaster. You do NOT put cheese in the toaster. Move the toast to a baking tray." },
      { title: "Cheese goes ON the toast", body: "Lay the cheese on top of the toast. Cover the whole slice so it melts evenly." },
      { title: "Under the grill", body: "Put the tray under the grill on medium. Stay there. Don't go anywhere. It takes about 2–3 minutes." },
      { title: "Take it out at golden", body: "When the cheese is bubbling and golden brown — take it out. Wait 30 seconds before biting. Molten cheese burns." },
    ],
    warnings: [
      "Never put cheese inside the toaster. It will melt onto the elements and could catch fire.",
      "Use an oven glove. The tray is hot. Hot tray + skin = bad day.",
      "Stay with the grill. 2 minutes is perfect. 5 minutes is a fire.",
    ],
    keywords: "how to make cheese on toast, cheese on toast recipe, toasted cheese, cheese toast",
    schema: {
      prepTime: "PT2M",
      cookTime: "PT3M",
      totalTime: "PT5M",
      yield: "1 serving",
      category: "Snack",
      cuisine: "British",
    },
  },
  {
    slug: "boiled-rice",
    title: "How to Boil Rice",
    shortTitle: "Boiled Rice",
    tagline: "Don't walk away. Seriously.",
    time: "20 min",
    difficulty: "EASY",
    image: ASSETS.friedRice,
    eyesOnIt: true,
    simulatorPath: "/simulator/boiled-rice",
    ingredients: [
      "1 mug of rice (long-grain or basmati)",
      "2 mugs of water",
      "Pinch of salt",
    ],
    tools: ["Saucepan with lid", "Hob"],
    steps: [
      { title: "Rinse the rice", body: "Tip rice into a sieve. Run cold water through until it runs clear. This stops it being gluey." },
      { title: "Into the pan", body: "Put rice + 2 mugs of water + a pinch of salt into the saucepan. Lid on. Hob on high." },
      { title: "Bring it to the boil", body: "Wait until you see bubbles. Then turn the heat DOWN to low. Keep the lid on." },
      { title: "Don't lift the lid (10–12 min)", body: "Set a timer. Do not lift the lid to peek — the steam is doing the work." },
      { title: "Rest, then fluff", body: "Turn the heat off. Leave it 2 minutes. Lift lid. Fluff with a fork. Done." },
    ],
    warnings: [
      "Keep your eyes on it. If you walk away with the heat too high, the water boils off, the rice burns, the pan dies.",
      "Stuck-on burnt rice is a 40-minute washing-up problem. Don't do that to yourself.",
      "Lid stays ON. Steam is doing the cooking.",
    ],
    keywords: "how to boil rice, perfect boiled rice, simple rice recipe teens",
    schema: { prepTime: "PT2M", cookTime: "PT15M", totalTime: "PT17M", yield: "2 servings", category: "Side", cuisine: "Global" },
  },
  {
    slug: "fried-rice",
    title: "Easy Fried Rice",
    shortTitle: "Fried Rice",
    tagline: "Best with day-old rice. Quick and savage.",
    time: "10 min",
    difficulty: "EASY",
    image: ASSETS.friedRice,
    ingredients: [
      "2 mugs of cooked, cold rice (yesterday's is perfect)",
      "1 egg",
      "1 spring onion, chopped",
      "A handful of frozen peas",
      "2 tbsp soy sauce",
      "1 tbsp oil",
    ],
    tools: ["Frying pan or wok", "Spatula"],
    steps: [
      { title: "Heat the pan", body: "Put oil in a pan on high heat. Wait until it shimmers." },
      { title: "Scramble the egg", body: "Crack egg in. Stir fast for 30 seconds. Push to the side of the pan." },
      { title: "Add rice + peas", body: "Tip in the cold rice and frozen peas. Stir-fry, breaking up clumps, for 2 minutes." },
      { title: "Soy + spring onion", body: "Pour soy sauce around the edge of the pan. Toss it all together. Add spring onion." },
      { title: "Serve", body: "Eat immediately. Don't let it sit — fried rice goes sad if it cools in the pan." },
    ],
    warnings: [
      "Use COLD rice. Fresh hot rice goes mushy. Day-old from the fridge is the move.",
      "Pan must be hot before the rice goes in. Cold pan = soggy rice.",
    ],
    keywords: "easy fried rice recipe, fried rice with leftover rice, simple wok recipe",
    schema: { prepTime: "PT3M", cookTime: "PT7M", totalTime: "PT10M", yield: "2 servings", category: "Main", cuisine: "Asian" },
  },
  {
    slug: "sushi-rolls",
    title: "No-Cook Sushi Hand Rolls",
    shortTitle: "Sushi Hand Rolls",
    tagline: "No raw fish. No knife skills. Just rolls.",
    time: "15 min",
    difficulty: "MEDIUM",
    image: ASSETS.sushi,
    ingredients: [
      "Cooked sushi rice (or any cooked short-grain rice, cooled)",
      "Nori sheets (seaweed)",
      "Cucumber, sliced into long sticks",
      "Avocado, sliced",
      "Cooked prawns or canned tuna (optional)",
      "Soy sauce for dipping",
    ],
    tools: ["Bowl", "Knife", "A flat hand"],
    steps: [
      { title: "Cut nori in half", body: "Take a sheet of nori. Cut it in half so you have a rectangle. Rough side faces up." },
      { title: "Add rice", body: "Put 2 tablespoons of cooled rice on the left third of the nori. Spread it out flat." },
      { title: "Add fillings", body: "Lay cucumber, avocado, and prawns/tuna diagonally across the rice." },
      { title: "Roll into a cone", body: "Fold the bottom-left corner of the nori over the filling, then keep rolling diagonally into a cone shape." },
      { title: "Dip + eat", body: "Dip the open end gently into soy sauce. Eat in 2 bites max." },
    ],
    warnings: [
      "Don't soak the nori — it gets floppy fast. Eat hand rolls within a few minutes of making.",
      "If you don't have sushi rice, regular short-grain works. Long-grain rice will fall apart.",
    ],
    keywords: "easy sushi hand rolls, no cook sushi, beginner sushi recipe",
    schema: { prepTime: "PT15M", cookTime: "PT0M", totalTime: "PT15M", yield: "4 rolls", category: "Lunch", cuisine: "Japanese" },
  },
  {
    slug: "saucepan-heating",
    title: "No Microwave, No Problem",
    shortTitle: "Heating in a Saucepan",
    tagline: "Heat anything up using just a pan and a hob.",
    time: "5 min",
    difficulty: "EASY",
    image: ASSETS.saucepan,
    simulatorPath: "/simulator/saucepan-heating",
    ingredients: [
      "Whatever you want to heat (soup, beans, leftovers, pasta sauce, etc.)",
      "A splash of water (only if it's thick / sticky / dry)",
    ],
    tools: ["Saucepan", "Wooden spoon or spatula", "Hob"],
    steps: [
      { title: "Pick the right pan", body: "Small thing? Small pan. Big thing? Bigger pan. Don't use a giant pan for a tiny portion — it sticks and burns." },
      { title: "Cold pan, cold food", body: "Tip the food into a cold saucepan. Don't preheat first." },
      { title: "Medium heat, lid OFF", body: "Turn the hob to medium. Lid stays off so you can see what's happening." },
      { title: "STIR every 30 seconds", body: "This is the whole job. Stir. Wait 30 seconds. Stir again. Stops sticking + burning." },
      { title: "Check it's hot", body: "Touch a clean spoon to the bottom of the food. If the spoon is hot for 3+ seconds, it's hot enough to eat." },
    ],
    warnings: [
      "Tomato-based sauces SPIT when they boil. Lid on, low heat, stand back.",
      "Don't leave the kitchen. The whole point of saucepan heating is being in the room.",
      "If it starts smoking, the heat is too high. Take the pan off the hob, turn heat down, then return.",
    ],
    keywords: "how to heat food without microwave, reheat food in a pan, no microwave recipes",
    schema: { prepTime: "PT1M", cookTime: "PT4M", totalTime: "PT5M", yield: "1 portion", category: "Technique", cuisine: "Global" },
  },
  {
    slug: "scrambled-eggs",
    title: "Scrambled Eggs (the Soft Way)",
    shortTitle: "Scrambled Eggs",
    tagline: "Low heat. Stir slowly. Off the pan early.",
    time: "5 min",
    difficulty: "EASY",
    image: ASSETS.eggs,
    ingredients: [
      "2 eggs",
      "A small knob of butter",
      "Splash of milk (optional, ~1 tsp)",
      "Pinch of salt",
    ],
    tools: ["Small non-stick saucepan or frying pan", "Spatula", "Bowl", "Fork"],
    steps: [
      { title: "Crack and whisk", body: "Crack 2 eggs into a bowl. Add salt + milk if using. Whisk with a fork until the yolk and white are one colour." },
      { title: "Low heat + butter", body: "Put the pan on LOW heat. Add butter. Wait until it just melts — don't let it brown." },
      { title: "Eggs in, stir slowly", body: "Pour the eggs in. Stir gently with a spatula every few seconds, scraping the bottom." },
      { title: "Stop early", body: "Take the pan OFF the hob when the eggs still look a bit wet. They'll keep cooking from residual heat. That's the trick." },
      { title: "Onto toast", body: "Slide onto toast. Eat immediately. Cold scrambled eggs are sadness." },
    ],
    warnings: [
      "High heat = rubber eggs. Always low heat.",
      "Stop cooking when they look slightly underdone. The pan finishes the job.",
      "Don't add cheese mid-cook — stir it in OFF the heat at the end so it doesn't go stringy.",
    ],
    keywords: "how to make scrambled eggs, soft scrambled eggs, easy egg recipe for teens",
    schema: { prepTime: "PT1M", cookTime: "PT4M", totalTime: "PT5M", yield: "1 serving", category: "Breakfast", cuisine: "Global" },
  },
  {
    slug: "simple-pasta",
    title: "Simple Pasta (Tomato + Cheese)",
    shortTitle: "Simple Pasta",
    tagline: "Salted boiling water. Sauce in a separate pan. Combine.",
    time: "15 min",
    difficulty: "EASY",
    image: ASSETS.pasta,
    ingredients: [
      "100g pasta (penne, fusilli or spaghetti)",
      "1 tin of chopped tomatoes (or a jar of tomato sauce)",
      "1 clove garlic, crushed (optional)",
      "Olive oil",
      "Pinch of salt for the water (LOTS)",
      "Grated cheese to serve",
    ],
    tools: ["Big saucepan", "Smaller saucepan", "Colander or sieve", "Wooden spoon"],
    steps: [
      { title: "Big pan of salty water", body: "Fill the big pan with water. Add a HEAPED tablespoon of salt — the water should taste like seawater. Lid on. Boil." },
      { title: "Pasta in", body: "When it's boiling hard, tip the pasta in. Stir once so it doesn't stick. Set a timer for the time on the packet minus 1 minute." },
      { title: "Sauce", body: "While pasta cooks: in the smaller pan, glug of olive oil + garlic on LOW for 30 sec. Add tomatoes + pinch of salt. Bubble gently for 5–7 min." },
      { title: "Drain (keep a mug of water!)", body: "Just before draining, save a mug of the starchy pasta water. Drain pasta in the colander." },
      { title: "Combine + serve", body: "Tip pasta into the sauce pan. Add a splash of pasta water. Stir 30 seconds. Onto plates. Cheese on top." },
    ],
    warnings: [
      "Water needs to be properly salty — under-salted water = bland pasta forever.",
      "Don't drain pasta-water away without saving a mug. It rescues the sauce if it's too thick.",
      "Watch the boil-over: lid off when pasta goes in, or set the lid skewed.",
    ],
    keywords: "easy pasta recipe, simple tomato pasta, beginner pasta for teens",
    schema: { prepTime: "PT2M", cookTime: "PT13M", totalTime: "PT15M", yield: "1 serving", category: "Main", cuisine: "Italian" },
  },
  {
    slug: "beans-on-toast",
    title: "Baked Beans on Toast",
    shortTitle: "Beans on Toast",
    tagline: "The national dish. 5 ingredients. 5 minutes.",
    time: "5 min",
    difficulty: "EASY",
    image: ASSETS.beans,
    simulatorPath: "/simulator/saucepan-heating",
    ingredients: [
      "1 tin of baked beans",
      "2 slices of bread",
      "Butter",
      "Optional: grated cheese on top",
    ],
    tools: ["Small saucepan", "Toaster", "Wooden spoon"],
    steps: [
      { title: "Beans into the pan", body: "Tip the whole tin of beans into a small saucepan. Turn the hob to MEDIUM." },
      { title: "Bread into the toaster", body: "While the beans warm up, put 2 slices of bread in the toaster. Push lever down." },
      { title: "Stir the beans", body: "Stir the beans every 30 seconds. They go from cold to hot in about 3 minutes. Don't let them stick." },
      { title: "Butter the toast", body: "When the toast pops up, butter it straight away while it's hot." },
      { title: "Beans on top", body: "Toast on plate. Beans over the top. Cheese on top of beans if you want a luxury upgrade. Eat immediately." },
    ],
    warnings: [
      "Tin lids are sharp. Use a tin opener properly, don't try to bend the lid back.",
      "Beans spit when they boil. Lower the heat the moment you see the first bubble.",
      "Don't put the beans IN the toaster. (We've said this before.)",
    ],
    keywords: "beans on toast recipe, baked beans on toast, simple british teen recipe",
    schema: { prepTime: "PT1M", cookTime: "PT4M", totalTime: "PT5M", yield: "1 serving", category: "Snack", cuisine: "British" },
  },
];

export const getRecipe = (slug) => RECIPES.find((r) => r.slug === slug);
